import { SocialHeadline } from 'autogen/translation-keys/trans-website-articleblock';
import { SvgSprite } from 'modules/svgSprite';
import { useTranslation } from 'react-i18next';
import { breakpoint, sizes } from 'variables';
import styled from 'styled-components';
import {
    FontFontFamilyPrimary,
    ColorBrandBlue1,
    FontCaptionLineHeightMedium,
    ColorNeutralDarkGrey
} from 'autogen/design-tokens/tokens';
import LinkAction from 'components/shared/Routing/components/LinkAction';
import type { LinkAction as LinkActionType } from 'components/shared/Routing/components/LinkAction/shared/types';

const Container = styled.div`
    display: none;
    background-color: #ffffff;
    margin-bottom: 15px;
    padding: 20px;
    text-align: center;
    font-family: ${FontFontFamilyPrimary};

    ${breakpoint.up(sizes.md)} {
        display: block;
    }
`;

const ShareTitle = styled.h2`
    font-size: 1.23em;
    line-height: ${FontCaptionLineHeightMedium};
    color: ${ColorBrandBlue1};
    margin-bottom: 25px;
`;

const SocialLink = styled.a`
    display: inline-block;
    border: 1px solid ${ColorNeutralDarkGrey};
    overflow: hidden;
    padding: 7px 3px;
    width: 26px;
    max-height: 26px;
    border-radius: 100%;
    margin: 0 2px;
    cursor: pointer;

    & > svg {
        height: 10px;
    }
`;

const FacebookSocialLink = styled(LinkAction)`
     display: inline-block;
    border: 1px solid ${ColorNeutralDarkGrey};
    overflow: hidden;
    padding: 7px 3px;
    width: 26px;
    max-height: 26px;
    border-radius: 100%;
    margin: 0 2px;
    cursor: pointer;

    & > svg {
        height: 10px;
    }
`;

export default function Share(props: { facebookShareUrl: LinkActionType }) {
    const { facebookShareUrl } = props;
    const { t } = useTranslation();

    return (
        <Container>
            <ShareTitle>{t(SocialHeadline)}</ShareTitle>
            <FacebookSocialLink action={facebookShareUrl}>
                <SvgSprite sprite="SocialFacebook" />
            </FacebookSocialLink>
            <SocialLink
                data-pin-do="buttonPin"
                data-pin-custom="true"
                className="js-pinterestPin"
                href="https://www.pinterest.com/pin/create/button/"
            >
                <SvgSprite sprite="SocialPinterest" />
            </SocialLink>
        </Container>
    );
}
